import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'info-menu',
  templateUrl: './info-menu.component.html',
  styleUrls: ['./info-menu.component.scss'],
  standalone: false
})
export class InfoMenuComponent implements OnInit {
  swirlVersion: string | null = '';
  isSupportFormEnabled: boolean = false;

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    this.swirlVersion = this.authService.getSwirlVersion();
  }
}
